// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.ReferenceFilterValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { ReferenceFilterOperation } from "abweb/dto/generated/inputargs/ReferenceFilterOperation";
import { FilterValue } from "abweb/dto/inputargs/FilterValue";
export class ReferenceFilterValueBase extends FilterValue {
  /** Do NOT invoke directly, instead use strongly typed createReferenceFilterValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.ReferenceFilterValue";
  }
  initFromJson(json, deserializeContext) {
    this.initReferenceFilterValue(json.componentGuid != null ? json.componentGuid : null, json.displayValue != null ? json.displayValue : null, json.isCaseSensitive != null ? json.isCaseSensitive : null, json.isOpNegated != null ? json.isOpNegated : null, json.op != null ? ReferenceFilterOperation.fromJson(json.op) : null, json.refID != null ? json.refID : null, json.stringValue != null ? json.stringValue : null);
  }
  initReferenceFilterValue(componentGuid, displayValue, isCaseSensitive, isOpNegated, op, refID, stringValue) {
    this.initFilterValue(componentGuid);
    this._displayValue = displayValue;
    this._isCaseSensitive = isCaseSensitive;
    this._isOpNegated = isOpNegated;
    this._op = op;
    this._refID = refID;
    this._stringValue = stringValue;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._displayValue != null) {
      retVal["displayValue"] = this._displayValue;
    }
    retVal["isCaseSensitive"] = this._isCaseSensitive;
    retVal["isOpNegated"] = this._isOpNegated;
    retVal["op"] = this._op;
    if (this._refID != null) {
      retVal["refID"] = this._refID;
    }
    if (this._stringValue != null) {
      retVal["stringValue"] = this._stringValue;
    }
    return retVal;
  }
  get displayValue() {
    return this._displayValue;
  }
  set displayValue(value) {
    this._displayValue = value;
  }
  get isCaseSensitive() {
    return this._isCaseSensitive;
  }
  set isCaseSensitive(value) {
    this._isCaseSensitive = value;
  }
  get isOpNegated() {
    return this._isOpNegated;
  }
  set isOpNegated(value) {
    this._isOpNegated = value;
  }
  get op() {
    return this._op;
  }
  set op(value) {
    this._op = value;
  }
  get refID() {
    return this._refID;
  }
  set refID(value) {
    this._refID = value;
  }
  get stringValue() {
    return this._stringValue;
  }
  set stringValue(value) {
    this._stringValue = value;
  }
}
//# sourceMappingURL=ReferenceFilterValueBase.js.map
